<template>
  <card 
    class="card-location" 
    v-observe-visibility="{
      callback: visibilityChanged,
      once: true,
    }"
  >
    <div class="row header">
      <div class="col">
        <div class="name">{{ location.name }}</div>
        <div class="location">{{ location.location }}</div>
      </div>
      <div class="col">
        <div class="time-period">
          <i class="fa fa-clock-o"></i>Last 30 Days
        </div>
      </div>
    </div>
    <div class="row body">
      <div class="col-xl-4 padding-left">
        <stats-card>
          <div slot="header">
            <p class="card-category">Redemptions</p>
          </div>
          <div slot="icon">
            <img src="@/assets/static/img/stats/total-redemptions.svg" alt="..."/>
          </div>
          <div slot="number">
            <h4 class="number">{{ total }}</h4>
          </div>
        </stats-card>
      </div>
      <div class="col-xl-4 padding-middle">
        <stats-card>
          <div slot="header">
            <p class="card-category">Clicks</p>
          </div>
          <div slot="icon">
            <img src="@/assets/static/img/stats/profile-clicks.svg" alt="..."/>
          </div>
          <div slot="number">
            <h4 class="number">{{ profileClicks }}</h4>
          </div>
        </stats-card>
      </div>
      <div class="col-xl-4 padding-right">
        <stats-card>
          <div slot="header">
            <p class="card-category">Impressions</p>
          </div>
          <div slot="icon">
            <img src="@/assets/static/img/stats/brand-impressions.svg" alt="..."/>
          </div>
          <div slot="number">
            <h4 class="number">{{ brandImpressions }}</h4>
          </div>
        </stats-card>
      </div>
    </div>
  </card>
</template>

<script>
  import { ObserveVisibility } from "vue-observe-visibility";
  
  import Card from './Card.vue'
  import StatsCard from './StatsCard.vue'

  export default {
    directives: {
      ObserveVisibility
    },
    components: {
      Card,
      StatsCard,
    },
    props: {
      location: Object,
    },
    data: function () {
      return {
        counts: this.location.counts,
      }
    },
    methods: {
      getCountDisplay(number) {
        var number_display = number;
        if (number >= 10000) {
          number_display = Math.floor(number_display / 100)
          number_display = number_display / 10
          number_display = number_display + 'k'
        }
        return number_display.toString()
      },
      async visibilityChanged (isVisible, entry) {
        if (isVisible) {
          if (!this.location.counts) {
            await this.$store.dispatch('getMerchantCardCounts', this.location.id)
            this.counts = this.location.counts;
          }
        }
      }
    },
    computed: {
      total() {
        if (this.counts) {
          return this.getCountDisplay(this.counts.total)
        } else {
          return '-'
        }
      },
      profileClicks() {
        if (this.counts) {
          return this.getCountDisplay(this.counts.profile_clicks)
        } else {
          return '-'
        }
      },
      brandImpressions() {
        if (this.counts) {
          return this.getCountDisplay(this.counts.brand_impressions)
        } else {
          return '-'
        }
      },
    },
    watch: {
      async location () {
        if (!this.location.counts) {
          await this.$store.dispatch('getMerchantCardCounts', this.location.id)
        }
        this.counts = this.location.counts;
      },
    },
    mounted: async function () {
      // if (!this.location.counts) {
      //   await this.$store.dispatch('getMerchantCardCounts', this.location.id)
      //   this.counts = this.location.counts;
      // }
    }
  }
</script>
